import { Injectable } from '@angular/core';

@Injectable()
export class BasedAircraft {
    single: boolean;
    jet: boolean;
    multi: boolean;
    helicopter: boolean;
    other: boolean;
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/based-aircraft.ts
 **/